import { giphyYellow } from '@giphy/js-brand'
import { IGif } from '@giphy/js-types'
import { Tooltip } from '@giphy/react-giphy-brand'
import React, { SyntheticEvent, useContext } from 'react'
import { editChannel } from 'shared/api/channels'
import gifSkeleton from 'shared/components/gif-skeleton'
import styled, { css } from 'styled-components'
import ChannelPageContext from './context/channel-page'
import MessageContext from './context/message'
import RefreshDataContext from './context/refresh-data'
import { useCanManageCollection } from 'shared/hooks/use-permissions'

const AddFeaturedGifOverlay = ({ gif, isHovered }) => {
    const { channel } = useContext(ChannelPageContext)
    const { sendMessage } = useContext(MessageContext)
    const { refreshChannel } = useContext(RefreshDataContext)
    const canManage = useCanManageCollection()
    // don't show featured gif start on root channels
    // only show them on collection pages
    // and abort if can't manage of course
    if (!channel || !channel.parent || !canManage) {
        return null
    }
    const isStarred = channel.featured_gif?.id === gif.id

    const onClick = async (gif: IGif, e: SyntheticEvent<HTMLElement>) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            // @ts-ignore featured_gif is usually a gif, but not when passed to edit
            await editChannel({ ...channel, featured_gif: isStarred ? '' : gif.id })
            sendMessage(`Success! Featured GIF updated`, 'success')
        } catch (error) {
            sendMessage(`Error updating featured GIF :(`, 'error')
        }
        refreshChannel({ ...channel, featured_gif: isStarred ? gifSkeleton() : gif })
    }
    const label = isStarred
        ? 'Remove as featured GIF. Channel will default to Most Recent'
        : "Set as collection's featured GIF"
    const maxWidth = isStarred ? 200 : 250
    return (
        <Overlay isStarred={isStarred} isHovered={isHovered}>
            <Tooltip label={label} maxWidth={maxWidth} offsetY={6}>
                <div className="ss-star" onClick={e => onClick(gif, e)} />
            </Tooltip>
        </Overlay>
    )
}

const Overlay = styled.div<{ isHovered: boolean; isStarred: boolean }>`
    display: flex;
    margin: 10px;
    position: absolute;
    top: 0;
    left: 0;
    ${props =>
        props.isStarred &&
        css`
            color: ${giphyYellow};
        `}
    ${props =>
        !props.isHovered &&
        css`
            display: none;
        `}
    .ss-star {
        height: 17px;
        transition: transform 200ms ease-out;
        &:hover {
            color: ${giphyYellow};
            transform: scale(1.2);
        }
    }
`

export default AddFeaturedGifOverlay
